import PilotageList from 'src/containers/PilotageList/PilotageList'

export default PilotageList
